import React, { useEffect, useState, useRef } from "react"
import { Container, Row, Col, Button, Overlay, Tooltip } from "react-bootstrap"
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon
} from "react-share";

import { CopyToClipboard } from "react-copy-to-clipboard";
import "./News.scss"

const ShareNews = (props) => {
    const shareurl = typeof window !== 'undefined' ? window.location.href : ''
    const [Shareicons, setShareicons] = React.useState(false);
    const [copied, setCopied] = useState(false);
    const target = useRef(null);
    const openShareicons = () => {
        setShareicons(true);
    }

    const closeShareicons = () => {
        setShareicons(false);
    }
    const trackerShare = (event) => {
        let share = typeof window !== 'undefined' ? window.location.href : ''
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Share - social icons',
            'formType': event + ' - ' + share,
            'formId': 'Share',
            'formName': 'Share',
            'formLabel': 'Share'
        });
    }
    return (

        <div className="share-info">
            <a className="share-info-icon" href={"javascript:;"} onClick={openShareicons} onMouseLeave={closeShareicons}>
                <i className="icon-share-grey"></i>
                <span className="desktop-text">Share this Article</span>
                <span className="mobile-text">Share</span>
                {Shareicons &&
                    <div onMouseEnter={openShareicons} onMouseLeave={closeShareicons} className="property-share-social-icons">
                        <FacebookShareButton onClick={() => trackerShare('FacebookShareButton')} url={shareurl} className="my-share-button facebook-share">
                            <FacebookIcon size={32} round={false} borderRadius={`10`} />
                        </FacebookShareButton>
                        <TwitterShareButton onClick={() => trackerShare('TwitterShareButton')} url={shareurl} className="my-share-button twitter-share">
                            <TwitterIcon size={32} round={false} borderRadius={`10`} />
                        </TwitterShareButton>
                        <LinkedinShareButton onClick={() => trackerShare('LinkedinShareButton')} url={shareurl} className="my-share-button linkedin-share">
                            <LinkedinIcon size={32} round={false} borderRadius={`10`} />
                        </LinkedinShareButton>
                        <WhatsappShareButton onClick={() => trackerShare('WhatsappShareButton')} url={shareurl} className="my-share-button whatsapp-share">
                            <WhatsappIcon size={32} round={false} borderRadius={`10`} />
                        </WhatsappShareButton>
                        <CopyToClipboard
                            options={{ debug: props.debug, message: "" }}
                            onCopy={() => setCopied(true)}
                            text={shareurl}
                        >
                            <button className="" ref={target} href={"javascript:void(0)"} onClick={() => {
                                setCopied(true)
                                setTimeout(() => {
                                    setCopied(false)
                                }
                                    , 1000)
                            }}>
                                <i className="copy-icon"></i>
                            </button>
                        </CopyToClipboard>
                    </div>
                }
            </a>
            <Overlay target={target.current} show={copied} placement="right">
                {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                        Copied!
                    </Tooltip>
                )}
            </Overlay>

            {props.brochure && props.brochure.length != 0 ?
                <a href={props.brochure[0].srcUrl} target="_blank" className="">
                    <i className="icon-print"></i>
                    <span>Print Brochure</span>
                </a>
                : ''}
        </div>
    )
}
export default ShareNews